<template>
  <div class="info mk-flex-column-start-center">
    <h2>国家药监局关于宣传贯彻《中华人民共和国疫苗管理法》的通知</h2>
    <p style="text-align: center">
      各省、自治区、直辖市药品监督管理局，新疆生产建设兵团药品监督管理局，局机关各司局、各直属单位： </p><p>
      《中华人民共和国疫苗管理法》（以下简称《疫苗管理法》）于2019年6月29日由第十三届全国人民代表大会常务委员会第十一次会议审议通过，自2019年12月1日起施行。为做好《疫苗管理法》宣传贯彻工作，现将有关事项通知如下：
      一、充分认识宣传贯彻《疫苗管理法》的重要意义疫苗关系人民群众健康，关系公共卫生安全和国家安全，是国家战略性、公益性产品。党中央、国务院高度重视疫苗监管工作，习近平总书记、李克强总理多次作出重要指示批示，要求加快完善疫苗药品监管长效机制，完善法律法规和制度规则。制定《疫苗管理法》，是贯彻党中央、国务院关于加强疫苗监管工作决策部署的重要举措。《疫苗管理法》坚持以人民为中心的思想，将中央部署的疫苗监管新举措以法律形式固化，将分散的疫苗管理规范整合集成，对疫苗研制、生产、流通、预防接种及监督管理作出系统性规定，以立法促改革，以立法强监管，以立法保权益。《疫苗管理法》是全球首部综合性疫苗管理法律，充分体现了党中央对疫苗的高度重视，对促进疫苗产业创新和行业健康发展，对保证疫苗安全、有效、可及，对重塑人民群众疫苗安全信心，对保护和促进公众健康，具有重要意义。各单位要从贯彻落实党中央、国务院关于加强疫苗管理的重要指示批示精神，从坚决维护广大人民群众最根本利益的高度，充分认识宣传贯彻《疫苗管理法》的重要性和必要性，按照“科学立法、严格执法、公正司法、全民守法”的要求，进一步增强责任感和使命感，抓紧抓好抓实《疫苗管理法》的宣传贯彻工作，积极开展《疫苗管理法》的学习、宣传和培训，抓紧制定完善相关配套制度，切实加强疫苗监管能力建设，积极做好法律实施的准备工作。要切实履行监管职责，强化执法检查，严厉打击违法行为，积极保障公众健康。</p><p>
      二、深刻领会《疫苗管理法》的精神实质和基本内容以党的十九大和十九届二中、三中全会精神为指导，认真贯彻落实习近平总书记对疫苗监管工作重要指示精神，明确工作目标，强化学习宣传培训，深入领会和准确把握《疫苗管理法》的精神实质和基本内容。各级药品监督管理部门要紧紧围绕学懂法律条文，学通法律精神，努力营造法律贯彻执行良好氛围的工作目标，突出针对性和实效性，深入开展学习、宣传和培训工作，强化企业主体意识、监管部门责任意识、群众权利意识和社会监督意识。</p><p>
      （一）制定切实可行的学习培训计划。要把学习宣传贯彻《疫苗管理法》作为贯彻“不忘初心、牢记使命”主题教育活动的一项具体措施，作为当前药品监管的一项重要工作，制定学习培训计划，明确学习任务和具体要求，落实责任分工和督查考核，做到有计划、有目标、有执行、有考核。要着重抓好领导干部的学习，主要负责同志以身作则，带头学习。要通过举办培训班、研讨会、专题讲座、网络培训和送法下基层等方式，紧密结合监管实际，强化一线执法人员学习培训，进一步提高疫苗监管人员的依法行政水平和能力。要指导和督促本行政区域内的疫苗上市许可持有人、流通配送和接种单位认真学习领会《疫苗管理法》，全面落实主体责任，形成全方位、多层次、无死角的学习宣传格局。</p><p>
      （二）把握学习重点。牢牢把握“安全第一、风险管理、全程管控、科学监管、社会共治”的基本原则，认真学习最严格的疫苗管理制度，认真学习疫苗全生命周期质量管理的具体要求和鼓励创新发展与保障可及的具体措施，认真学习各级政府与相关部门的具体责任，认真学习疫苗安全社会共治的具体规定，认真学习严惩重处违法行为的具体内容。</p><p>
      （三）创新学习宣传方式。把学习宣传贯彻《疫苗管理法》纳入公益性宣传范围，列入全民普法的重要内容，与全国儿童预防接种日、全国安全用药月等品牌活动相结合，深入开展《疫苗管理法》“进机关、进乡村、进社区、进学校、进企业、进单位”法治宣传教育主题活动，采取丰富多彩、生动活泼、群众喜闻乐见的形式和手段，开展形式多样的学习宣传活动。要加强学习宣传资源建设，依托互联网搭建《疫苗管理法》和疫苗安全知识科普资源库和专家库。充分利用报刊、广播、电影、电视、互联网、手机等各类媒介，开设专题专栏，组织专家，深入解读《疫苗管理法》的内容。将拍摄疫苗普法和科普微视频、微电影作为第十六届全国法治动漫微视频作品征集展示活动的一项重要内容，扩大宣传影响力，努力营造学习宣传《疫苗管理法》的良好氛围。</p><p>
      三、加强配套制度和监管能力建设，切实做好《疫苗管理法》实施的准备工作宣传贯彻《疫苗管理法》，是各级药品监督管理部门的重要职责，也是构建药品安全现代化治理体系的必然要求，重点要抓好配套制度和监管能力建设，积极做好《疫苗管理法》实施的准备工作。《疫苗管理法》将于2019年12月1日实施，规定了国家应当建立多项制度。目前，国家药品监督管理局正在组织力量，抓紧制订疫苗全程电子追溯制度、对疫苗生产实行严格准入制度、疫苗批签发制度、疫苗责任强制保险制度和疫苗安全信息统一公布等制度，抓紧推进相关规章和规范性文件、技术指南的制修订，并按照职业化检查员队伍建设的总体部署，加强监管队伍能力建设，完善飞行检查、有因检查、派驻检查等工作制度。地方各级药品监督管理部门要贯彻中央“地方各级党委和政府必须坚决扛起药品安全尤其是疫苗安全的政治责任，对辖区内疫苗药品安全工作负总责”的部署要求，积极向地方党委、政府汇报，在党委、政府统一领导下，加强疫苗监管能力和基础建设，与相关部门协调联动，推动完善《疫苗管理法》贯彻实施的配套政策。地方各级药品监督管理部门要按照部署安排，加快推进疫苗国家监管体系评估准备工作，按期完成自评估，对存在的不足和短板，制定详细工作计划。要以评估为契机，进一步建立健全质量管理体系，切实提升监管能力和水平。</p><p>
      四、切实强化疫苗药品监管执法，积极维护人民群众健康权益</p><p>
      （一）深入推进药品审评审批制度改革。鼓励疫苗药品创新和产品可及。鼓励多联多价疫苗和创新疫苗及防治重大疾病所需疫苗的研发，优化审评审批流程，对符合规定的品种予以优先审评审批。药品监督管理部门要提前介入，在法规政策和技术要求等方面对企业予以指导。加强对企业研制过程的监管，强化疫苗临床试验机构管理，依法严肃查处申请开展疫苗临床试验或者申请疫苗注册提供虚假数据、资料、样品的违法行为。</p><p>
      （二）加强监督检查，严厉打击疫苗药品领域违法行为。要牢固树立问题导向，坚持风险理念，统筹运用检查、检验、监测、投诉举报等手段排查风险，从源头防范疫苗质量风险。要做到对疫苗生产企业检查的高频次和全覆盖，依法严查重处违法违规生产行为。在对企业行政处罚的同时，还要处罚相关责任人，追责追刑到个人。要与相关部门联合采取诚信惩戒措施，对违法者实行行业禁入。按照《疫苗管理法》要求，要依职责强化储存、运输、配送以及预防接种中的疫苗质量监管，重点对冷链控制和流向追溯进行监督检查，依法查处违法违规行为；要督促上市许可持有人按要求开展疑似预防接种异常反应监测，制定并实施上市后风险管理计划，开展疫苗上市后研究和评价。</p><p>
      （三）强化疫苗监管队伍建设。通过培养、招录、资源整合等方式遴选一批作风过硬、业务精良的检查员，并持续加强业务培训和实战演练，不断提升监管队伍的整体素质和业务水平。 五、加强组织领导，确保《疫苗管理法》贯彻落实各级药品监督管理部门要把宣传贯彻《疫苗管理法》列入当前重要工作议事日程，针对疫苗监管特点，加强领导，明确任务，落实责任，周密部署，制定工作实施方案，建立相应的人员和财政经费投入保障机制。要将宣传贯彻《疫苗管理法》工作情况作为对部门和地方药品安全工作和普法工作监督检查和考核评价的重要内容，建立健全评估和监督检查机制，定期督查检查宣传贯彻情况，确保工作落到实处。国家药品监督管理局将在今年的药品督查检查中，把宣传贯彻《疫苗管理法》情况作为重要检查内容。各地要及时总结宣传贯彻《疫苗管理法》工作中好的经验和做法，以及反映出的问题和建议，有关情况请及时报送国家药品监督管理局政策法规司。
    </p>
  </div>
</template>

<script>


export default {
  name: 'information',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped>
  .info {
    background: #F9F9F9;
    padding: 63px 202px;
  }
  h2 {
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3160AD;
    line-height: 34px;
    margin-bottom: 32px;
  }
  p {
    text-align: left;
    word-wrap: break-word;
    /*background: #ffffff;*/
    padding: 38px;
  }
</style>
